<section>

    <!--Grid row-->
    <div class="row">

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 my-4">

            <!--Card-->
            <mdb-card cascade="true" class="cascading-admin-card">

                <!--Card Data-->
                <div class="admin-up">
                    <mdb-icon fas icon="fas fa-car" class="primary-color"></mdb-icon>
                    <div class="data">
                        <p>NEW RESERVATIONS</p>
                        <h4><strong>1000</strong></h4>
                    </div>
                </div>
                <!--/.Card Data-->

                <!--Card content-->
                <mdb-card-body [cascade]="true">
                    <div class="progress">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <!--Text-->
                    <p class="card-text">Better than last week (25%)</p>
                </mdb-card-body>
                <!--/.Card content-->

            </mdb-card>
            <!--/.Card-->

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 my-4">

            <!--Card-->
            <mdb-card cascade="true" class="cascading-admin-card">

                <!--Card Data-->
                <div class="admin-up">
                    <mdb-icon fas icon="chart-line" class="warning-color"></mdb-icon>
                    <div class="data">
                        <p>SALE</p>
                        <h4><strong>$200,000.00</strong></h4>
                    </div>
                </div>
                <!--/.Card Data-->

                <!--Card content-->
                <mdb-card-body cascade="true">
                    <div class="progress">
                        <div class="progress-bar bg grey darken-2" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <!--Text-->
                    <p class="card-text">Worse than last week (25%)</p>
                </mdb-card-body>
                <!--/.Card content-->

            </mdb-card>
            <!--/.Card-->

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 my-4">

            <!--Card-->
            <mdb-card cascade="true" class="cascading-admin-card">

                <!--Card Data-->
                <div class="admin-up">
                    <mdb-icon fas icon="money-bill-alt" class="light-blue lighten-1"></mdb-icon>
                    <div class="data">
                        <p>CASH</p>
                        <h4><strong>$100,000.00</strong></h4>
                    </div>
                </div>
                <!--/.Card Data-->

                <!--Card content-->
                <mdb-card-body cascade="true">
                    <div class="progress">
                        <div class="progress-bar grey darken-2" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <!--Text-->
                    <p class="card-text">Worse than last week (75%)</p>
                </mdb-card-body>
                <!--/.Card content-->

            </mdb-card>
            <!--/.Card-->

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 my-4">

            <!--Card-->
            <mdb-card cascade="true" class="cascading-admin-card">

                <!--Card Data-->
                <div class="admin-up">
                    <mdb-icon fas icon="fas fa-exclamation-triangle" class="red accent-2"></mdb-icon>
                    <div class="data">
                        <p>RESERVATIONS CANCELED</p>
                        <h4><strong>10</strong></h4>
                    </div>
                </div>
                <!--/.Card Data-->

                <!--Card content-->
                <mdb-card-body cascade="true">
                    <div class="progress">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <!--Text-->
                    <p class="card-text">Better than last week (25%)</p>
                </mdb-card-body>
                <!--/.Card content-->

            </mdb-card>
            <!--/.Card-->

        </div>
        <!--Grid column-->

    </div>
    <!--Grid row-->

</section>
